import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import TopHeader from "../../components/TopHeader";
import ExploreHero from "../../components/Explore/ExploreHero";
import { isDesktop } from "react-device-detect";
import Footer from "../../components/Footer";
import {
  ExploreTopArtists,
  ExploreTopEntertainment,
  ExploreTopInfluencers,
  ExploreTopTech,
  fetchExploreFeaturedUsers,
} from "../../utils/ExploreUtils";
import { AccountData, ThemeType } from "@markit/common.types";
import LoadingScreen from "../LoadingScreen";
import FeaturedPeople from "../../components/Explore/FeaturedPeople";
import { Colors } from "../../utils/colors";
import { Icon } from "@iconify/react";
import ExploreCategories from "../../components/Explore/ExploreCategories";
import useAsyncEffect from "../../hooks/useAsyncEffect";

const ExploreCategoryPage = () => {
  const { categoryName } = useParams();
  const [featuredPeople, setFeaturedPeople] = useState<AccountData[]>([]);
  const [isLoadingPage, setIsLoadingPage] = useState<boolean>(true);

  const styles = {
    gradientHeader: {
      backgroundColor: Colors.BLACK,
      height: isDesktop ? 400 : 310,
      width: "100%",
      minWidth: 0,
      alignItems: "center",
    },
    mainContentContainer: {
      paddingTop: isDesktop ? 40 : 30,
      paddingBottom: 100,
      paddingInline: 20,
      width: "100%",
      maxWidth: 1152,
      minWidth: 0,
      margin: "auto",
      backgroundColor: Colors.WHITE,
      gap: 40,
    },
    heroContainer: {
      width: "100%",
      maxWidth: 1152,
      minWidth: 0,
      margin: "auto",
      paddingInline: 20,
      gap: isDesktop ? 60 : 30,
    },
  };

  const featuredCategoryPeople = useMemo(
    () =>
      categoryName === "artists"
        ? ExploreTopArtists
        : categoryName === "influencers"
        ? ExploreTopInfluencers
        : categoryName === "entertainment"
        ? ExploreTopEntertainment
        : categoryName === "tech"
        ? ExploreTopTech
        : [],
    [categoryName]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useAsyncEffect(async () => {
    setIsLoadingPage(true);
    const featuredPeople = await fetchExploreFeaturedUsers(
      featuredCategoryPeople
    );
    setFeaturedPeople(featuredPeople);
    setIsLoadingPage(false);
  }, [featuredCategoryPeople]);

  if (isLoadingPage) {
    return <LoadingScreen />;
  } else {
    return (
      <div>
        <div style={{ ...styles.gradientHeader, boxSizing: "border-box" }}>
          <TopHeader eventTheme={ThemeType.Dark} />
          <div style={{ ...styles.heroContainer, boxSizing: "border-box" }}>
            <ExploreHero
              description={"Discover top creators on Markit."}
              title={categoryName}
            />
          </div>
        </div>
        <div
          className="ColumnNormal"
          style={{ ...styles.mainContentContainer, boxSizing: "border-box" }}
        >
          <FeaturedPeople
            featuredPeople={featuredPeople}
            title="Browse Creators"
            icon={
              <Icon
                icon="ion:people"
                height={25}
                style={{ color: Colors.BLACK }}
              />
            }
            subtext={`Browse the top creators in ${categoryName}`}
          />
          <ExploreCategories />
        </div>
        <Footer />
      </div>
    );
  }
};

export default ExploreCategoryPage;
